import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import SongCard from "@/components/SongCard";
import { Search } from "lucide-react";

export default function Songs() {
  const [songs, setSongs] = useState([]);
  const [genres, setGenres] = useState([]);
  const [q, setQ] = useState("");
  const [genre, setGenre] = useState("all");
  const [sort, setSort] = useState("latest");
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/songs/genres").then((r) => setGenres(r.data)); }, []);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      api.get("/songs", { params: { q: q || undefined, genre, sort, limit: 60 } })
        .then((r) => setSongs(r.data))
        .finally(() => setLoading(false));
    }, 200);
    return () => clearTimeout(t);
  }, [q, genre, sort]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="mb-12">
        <p className="eyebrow mb-3">The library</p>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight font-light">All songs.</h1>
      </div>

      <div className="flex flex-col md:flex-row md:items-center gap-4 mb-10">
        <div className="relative flex-1">
          <Search size={16} strokeWidth={1.5} className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-400" />
          <input
            data-testid="songs-search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search songs, albums, artists…"
            className="w-full h-12 pl-11 pr-4 rounded-full bg-white border border-[--sanctum-border] focus:outline-none focus:ring-2 focus:ring-neutral-300 text-sm"
          />
        </div>
        <div className="flex gap-2 overflow-x-auto pb-1">
          <button
            data-testid="filter-genre-all"
            onClick={() => setGenre("all")}
            className={`btn-pill text-xs whitespace-nowrap ${genre === "all" ? "btn-primary" : "btn-outline"}`}
          >
            All
          </button>
          {genres.map((g) => (
            <button
              key={g}
              data-testid={`filter-genre-${g.toLowerCase()}`}
              onClick={() => setGenre(g)}
              className={`btn-pill text-xs whitespace-nowrap ${genre === g ? "btn-primary" : "btn-outline"}`}
            >
              {g}
            </button>
          ))}
        </div>
        <select
          data-testid="sort-select"
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          className="h-11 px-4 rounded-full bg-white border border-[--sanctum-border] text-sm focus:outline-none"
        >
          <option value="latest">Newest</option>
          <option value="popular">Most played</option>
        </select>
      </div>

      {loading ? (
        <div className="text-neutral-400 text-sm">Loading library…</div>
      ) : songs.length === 0 ? (
        <div className="text-neutral-400 text-sm">No songs match your search.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 xl:gap-8">
          {songs.map((s, i) => <SongCard key={s.id} song={s} index={i} />)}
        </div>
      )}
    </div>
  );
}
